<template>
  <div :style="`width:100%;height:800px;overflow-y:scroll`">
    <webview
      ref="wviewPrint"
      @did-finish-load="print"
      :style="`min-height:100%`"
      :src="`file://${printUrl}`"
    ></webview>
  </div>
</template>
<script>
import fileSys from "../../fileoprators/fileSystem";
const fs = window.require("fs");
export default {
  name: "PViewer",
  data() {
    return {};
  },
  created() {},
  methods: {
    print() {
      try {
        this.$refs.wviewPrint.getWebContents().printToPDF(
          {
            pageSize: "A4"
          },
          (error, data) => {
            let pdfPath = fileSys.getCfgPath("ct.pdf");
            fileSys.deleteFile(pdfPath);
            fileSys.writeFile(pdfPath, data, (error) => {
              console.log(error);
            });
          }
        );
      } catch (e) {}
    }
  },
  mounted() {},
  props: {
    mapValues: {
      type: Object,
      default: () => {
        return {};
      }
    },

    printUrl: {
      type: String,
      default: ""
    },
    dispW: {
      type: Number,
      default: window.screen.width
    },
    dispH: {
      type: Number,
      default: window.screen.height - 50
    }
  }
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/topography/components/PViewer.vue